import classes from "./SectionContent.module.css";

function SectionContent({ subTitle, children }) {
  return (
    <div className={classes.content}>
      
      <p>{subTitle}</p>
      {children}
    </div>
  );
}

export default SectionContent;
